import Auth from "../components/auth/Auth";

const Login = () => {
    return (
        <div>
            <Auth />
        </div>
    );
  };
  
export default Login;
  